import { ReadonlySignal } from '@preact/signals-react';

import { OperationResult } from '@vp/common/core/OperationResult';
import { ProfileThemeModel } from '@vp/profile/core/model/ProfileThemeModel';

export abstract class ThemingManagerPort {
  abstract readonly theme: ReadonlySignal<ProfileThemeModel>;
  abstract updateTheme(theme: ProfileThemeModel, controller?: AbortController): Promise<OperationResult>;
}
